import { DOCUMENT, Inject, Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LazyLoadScriptService {
  private loadedLibraries: { [url: string]: ReplaySubject<void> } = {};

  constructor(@Inject(DOCUMENT) private document: Document) {}

  public loadScript(url: string): Observable<void> {
    if (!!this.loadedLibraries[url]) {
      return this.loadedLibraries[url].asObservable();
    }

    const script = this.document.createElement('script');
    script.type = 'text/javascript';

    if (url.includes('https://')) {
      script.src = url;
    } else {
      const href = this.document.getElementsByTagName('base')?.[0].getAttribute('href');
      script.src = href + url;
    }

    this.loadedLibraries[url] = new ReplaySubject();

    script.onload = () => {
      this.loadedLibraries[url].next();
      this.loadedLibraries[url].complete();
    };

    this.document.getElementsByTagName('head')[0].appendChild(script);
    return this.loadedLibraries[url].asObservable();
  }
}
